// import Vue from 'vue'
const uxConf = {
  params: {
    hoverActivationDelay: 300,
    tooltipActivationDelay: 500,
    tooltipTransition: 'el-zoom-in-left',
    tableSize: 'small', // medium | small | mini
    formSize: 'small', // medium | small | mini
    buttonCircle: false,
    buttonRound: false,
    buttonPlain: false
  }
}

uxConf.install = function (Vue, options) {
  Vue.$uxConf = uxConf.params
}
export default uxConf



// WEBPACK FOOTER //
// ./src/UxConfig.js